import React from 'react'

export default function IconUpload(props) {
  const { size = 20 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33341 10.666V5.23268L5.60008 6.96602L4.66675 5.99935L8.00008 2.66602L11.3334 5.99935L10.4001 6.96602L8.66675 5.23268V10.666H7.33341ZM4.00008 13.3327C3.63341 13.3327 3.31953 13.2021 3.05841 12.941C2.7973 12.6799 2.66675 12.366 2.66675 11.9993V9.99935H4.00008V11.9993H12.0001V9.99935H13.3334V11.9993C13.3334 12.366 13.2029 12.6799 12.9417 12.941C12.6806 13.2021 12.3667 13.3327 12.0001 13.3327H4.00008Z" fill="currentColor" />
    </svg>
  );
}
